import React from 'react';
import { Link } from 'react-router-dom';
import { PageRenderer } from '../components/site/PageRenderer';
import { Seo } from '../components/site/Seo';
import { useSiteContent } from '../context/SiteContentContext';
import { useContentfulCollection } from '../hooks/useContentfulCollection';

export function FaqPage() {
  const { siteContent } = useSiteContent();
  const page = siteContent.pages.faq;
  const { items: faqItems } = useContentfulCollection('faqItems', { pageSize: 100 });

  return (
    <>
      <Seo page={page} />
      <PageRenderer page={page} />
      <section className='content-section faq-section'>
        <div className='faq-grid'>
          {faqItems.map((item) => (
            <details key={item.slug} className='faq-item' id={item.slug}>
              <summary>
                <span>{item.question}</span>
                <span className='faq-category'>{item.category}</span>
              </summary>
              <p style={{ whiteSpace: 'pre-line' }}>{item.answer}</p>
              {item.downloadUrl ? (
                <a className='inline-link' href={item.downloadUrl} target='_blank' rel='noreferrer'>
                  Download supporting PDF
                </a>
              ) : null}
            </details>
          ))}
        </div>
      </section>
      <section className='content-section'>
        <div className='cta-banner reveal-item'>
          <div className='section-header'>
            <p className='section-label'>Still need a deeper answer?</p>
            <h2>Bring the production context, not just the question.</h2>
            <p className='section-copy'>Complex manufacturing conversations are easier when the team can see the part family, bottleneck, and deployment expectation together.</p>
          </div>
          <div className='hero-actions cta-banner-actions'>
            <Link className='primary-cta' to='/contact'>Talk with Rivelin</Link>
            <Link className='secondary-cta' to='/request-demo'>Book a demo</Link>
          </div>
        </div>
      </section>
    </>
  );
}
